<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SALES QUOTE UPDATE">
          <template slot="actions">
            <vs-button
              v-can="'create-edit-sales-quote'"
              icon-pack="feather"
              icon="icon-arrow-left"
              @click="backToSalesQuoteList"
              class="mr-4"
              color="primary"
              type="border"
            >
              Back to sales quote list
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <form autocomplete="off">
                <vs-table
                  :hoverFlat="true"
                  id="sample_list"
                  v-can="'create-edit-sales-quote'"
                  :data="itemList"
                  :sst="true"
                  stripe
                  class="table-dark-inverted table-auto vs-con-loading__container"
                >
                  <template slot="header">
                    <vs-input
                      icon-pack="feather"
                      icon="icon-search"
                      placeholder="Search here"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/2 xl:w-1/7 rounded-full"
                    />
                    <vs-button
                      id="place_order"
                      :disabled="cartItems.length === 0"
                      v-can="'create-edit-sales-quote'"
                      icon-pack="feather"
                      icon="icon-shopping-cart"
                      @click="onClickOpenCart"
                      class="mr-12"
                      color="primary"
                      type="filled"
                    >
                      Update sales quote ({{ cartItems.length }} products)
                    </vs-button>
                  </template>
                  <template slot="thead">
                    <vs-th>ITS PRODUCT CODE/NAME</vs-th>
                    <vs-th>CUSTOMER ITEM CODE/NAME</vs-th>
                    <vs-th width="10%">PACK SIZE (KG)</vs-th>
                    <vs-th width="10%">QUANTITY</vs-th>
                    <vs-th width="10%">UNIT PRICE (KG/{{ account_currency }})</vs-th>
                    <vs-th width="10%">INCOTERMS</vs-th>
                    <vs-th width="10%">TOTAL PRICE ({{ account_currency }})</vs-th>
                    <vs-th width="20%">ACTION</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr
                      :state="tr_item && tr_item.errors && tr_item.errors.length > 0 ? 'danger' : null"
                      :key="index_item"
                      v-for="(tr_item, index_item) in data"
                    >
                      <vs-td
                        :data="data[index_item].formulation_code"
                        v-if="data[index_item].__source == 'catalogue'"
                      >
                        <span class="font-bold">{{
                          data[index_item].formulation_code
                        }}</span>
                        <br />
                        {{ data[index_item].name }}
                      </vs-td>
                      <vs-td :data="data[index_item].product_code_name" v-else>
                        {{ data[index_item].product_code_name }}
                      </vs-td>
                      <vs-td v-if="data[index_item].__source == 'catalogue'">
                        <div
                          v-if="data[index_item].customer_item_code !== 'N/A'"
                        >
                          <span class="font-bold">{{
                            data[index_item].customer_item_code
                          }}</span>
                          <br />
                          {{ data[index_item].customer_item_name }}
                        </div>
                        <div v-else>N/A</div>
                      </vs-td>
                      <vs-td
                        :data="data[index_item].customer_product_code"
                        v-else
                      >
                        {{ data[index_item].customer_product_code }}
                      </vs-td>
                      <vs-td :data="data[index_item].pack_size">
                        <v-select
                          :clearable="true"
                          placeholder=""
                          v-model="data[index_item].pack_size"
                          :appendToBody="true"
                          :options="pack_size_options"
                          label="size"
                          :reduce="(option) => option.size"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        ></v-select>
                      </vs-td>
                      <vs-td v-if="data[index_item].__source == 'catalogue'">
                        <ValidationProvider
                          v-if="data[index_item].type === 'List'"
                          :vid="index_item + 'quantity'"
                          :name="index_item + 'quantity'"
                          v-slot="{ errors }"
                        >
                          <vs-input
                            v-on:input="
                              onChangeQty(data[index_item], index_item)
                            "
                            type="text"
                            v-model="data[index_item].quantity"
                            class="w-full"
                            :name="index_item + 'quantity'"
                            :danger="!!errors[0]"
                            :danger-text="errors[0]"
                            val-icon-danger="icon-x"
                            val-icon-pack="feather"
                          />
                        </ValidationProvider>
                        <span
                          class="ml-2"
                          v-if="
                            ['contract', 'Bespoke'].includes(
                              data[index_item].type
                            ) && !data[index_item].is_tier
                          "
                        >
                          {{ data[index_item].quantity }}
                        </span>
                        <span
                          class="ml-2"
                          v-if="
                            ['contract', 'Bespoke'].includes(
                              data[index_item].type
                            ) && data[index_item].is_tier
                          "
                        >
                          <span
                            v-for="(qty_obj, index) in data[index_item]
                              .quantity_array"
                            :key="index"
                          >
                            {{ qty_obj.quantity_from }} -
                            {{ qty_obj.quantity_to }} <br />
                          </span>
                        </span>
                      </vs-td>
                      <vs-td v-else>
                        
                        <ValidationProvider
                          v-if="!data[index_item].is_tier && data[index_item].__source == 'sales_quote'"
                          :vid="index_item + 'quantity'"
                          :name="index_item + 'quantity'"
                          v-slot="{ errors }"
                        >
                        
                          <vs-input
                            v-on:input="
                              onChangeQty(data[index_item], index_item)
                            "
                            type="text"
                            v-model="data[index_item].quantity"
                            class="w-full"
                            :name="index_item + 'quantity'"
                            :danger="!!errors[0]"
                            :danger-text="errors[0]"
                            val-icon-danger="icon-x"
                            val-icon-pack="feather"
                          />
                        </ValidationProvider>
                        <span class="ml-2" v-if="['contract', 'Bespoke', 'price'].includes(data[index_item].type) && !data[index_item].is_tier">
                          
                          <!-- {{ data[index_item].quantity}} -->
                          <vs-input
                            v-on:input="
                              onChangeQty(data[index_item], index_item)
                            "
                            type="text"
                            v-model="data[index_item].quantity"
                            class="w-full"
                            :name="index_item + 'quantity'"
                          />
                          
                        </span>
                        
                        <span class="ml-2" v-if="['contract', 'Bespoke'].includes(data[index_item].type) && data[index_item].is_tier">
                          
                          <span v-for="(qty_obj, index) in data[index_item].quantity_array" :key="index">
                            {{ qty_obj.quantity_from }} - {{ qty_obj.quantity_to }} <br>
                          </span>
                        </span>
                        <span class="ml-2" v-if="data[index_item].is_tier && !data[index_item].type">
                          <span
                            v-for="(qty_obj, index) in data[index_item]
                              .quantity"
                            :key="index"
                          >
                            {{ qty_obj.quantity_from }} -
                            {{ qty_obj.quantity_to }} <br />
                          </span>
                        </span>
                      </vs-td>
                      <vs-td :data="data[index_item].unit_price">
                        <!-- this is what display the array when open the popup  -->
                        <!-- <span
                          v-if="
                            !data[index_item].is_tier &&
                            data[index_item].__source !== 'catalogue'
                          "
                        >
                        {{ data[index_item] }}
                          {{ data[index_item].price }}
                        </span> -->
                        <span
                          v-if="
                            !data[index_item].is_tier &&
                            data[index_item].__source !== 'catalogue'
                          "
                        >
                        
                          {{ data[index_item].price }}
                        </span>
                        <span
                          v-if="
                            data[index_item].is_tier
                            
                          "
                        >
                          <!-- <div v-if="data[index_item].__source == 'sales_quote'">
                            <span 
                              v-for="(price_obj, index) in data[index_item].price"
                              :key="index"
                            >
                              {{ price_obj.price }} <br />
                            </span>
                          </div> -->
                          <span v-if="data[index_item].__source == 'catalogue'"
                            v-for="(price_obj, index) in data[index_item].price_array"
                            :key="index"
                          >
                            {{ price_obj.price }} <br />
                          </span>
                        </span>
                        
                        <span v-if="!data[index_item].is_tier">
                          {{data[index_item].unit_price}}
                        </span>
                        <span v-if="data[index_item].is_tier ">
                          <span v-for="(price_obj, index) in data[index_item].price_array" :key="index">
                            {{ price_obj.price }} <br>
                          </span>
                        </span>
                      </vs-td>

                      <vs-td :data="data[index_item].incoterm">
                        <v-select
                          :clearable="true"
                          placeholder=""
                          v-model="data[index_item].incoterm"
                          :appendToBody="true"
                          :options="incoterms"
                          label="code"
                          :reduce="(option) => option.code"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        ></v-select>
                      </vs-td>

                      <vs-td>
                        <span v-if="!data[index_item].is_tier">
                          {{
                            data[index_item].quantity
                              ? (
                                  Number(data[index_item].price) *
                                  data[index_item].quantity
                                ).toFixed(2)
                              : "0.00"
                          }}
                        </span>
                        <span v-if="data[index_item].is_tier"> N/A </span>
                      </vs-td>
                      <vs-td v-can="'create-edit-sales-quote'">
                        <div class="vx-row">
                          <vx-tooltip :text="`Remove from cart`" position="top">
                            <vs-button
                              class="mr-2"
                              :id="'remove_button' + '' + index_item"
                              v-if="checkItemInCart(data[index_item])"
                              @click.native="
                                onClickRemoveFromCart(
                                  data[index_item].formulation_id,
                                  index_item
                                )
                              "
                              size="small"
                              color="danger"
                              type="border"
                              icon-pack="feather"
                              icon="icon-delete"
                            ></vs-button>
                          </vx-tooltip>
                          <vx-tooltip
                            v-if="
                              ['contract', 'Bespoke'].includes(
                                data[index_item].type
                              ) && data[index_item].__source == 'catalogue'
                            "
                            text="Add/Update price tiers"
                            position="top"
                          >
                            <vs-button
                              :id="'add_button' + '' + index_item"
                              @click.native="
                                onClickCalculatePrice(
                                  data[index_item],
                                  index_item
                                )
                              "
                              size="small"
                              color="primary"
                              type="border"
                              icon-pack="feather"
                              icon="icon-plus"
                              >Price tiers</vs-button
                            >
                          </vx-tooltip>
                          <vx-tooltip
                            v-if="
                              data[index_item].is_tier &&
                              data[index_item].__source !== 'catalogue'
                            "
                            text="Add/Update price tiers"
                            position="top"
                          >
                            <vs-button
                              :id="'add_button' + '' + index_item"
                              @click.native="
                                onClickCalculatePrice(
                                  data[index_item],
                                  index_item
                                )
                              "
                              size="small"
                              color="primary"
                              type="border"
                              icon-pack="feather"
                              icon="icon-plus"
                              >Price tiers</vs-button
                            >
                          </vx-tooltip>
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </form>
            </ValidationObserver>
          </div>
        </vx-card>
        <calculate-product-sales-quote-price-pop-up
          @changeQtyLayer="changeQtyLayer"
          ref="calculateProductSalesQuotePricePopUp"
          v-bind:account_currency="account_currency"
        />
        
      </div>
    </div>
    <update-customer-sales-quote-pop-up v-bind:account_currency="account_currency" ref="updateCustomerSalesQuotePopUp" @backToSalesQuoteList="backToSalesQuoteList"/>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import Filter from "@/mixins/filter";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";
import Calculations from "@/mixins/Calculations";
import CalculateProductSalesQuotePricePopUp from "@/components/popups/customer/sales-quote/CalculateProductSalesQuotePricePopUp";
import UpdateCustomerSalesQuotePopUp from "@/components/popups/customer/sales-quote/UpdateCustomerSalesQuotePopUp";
import RmCatalogueErrorPopUp from "@/components/popups/inventory/rm-orders/RmCatalogueErrorPopUp";

const CustomerRepository = RepositoryFactory.get("customer");
const IncotermRepository = RepositoryFactory.get("incoterm");
const PackSizeRepository = RepositoryFactory.get("pack_size");

export default {
  name: "UpdateSalesQuote",
  components: {
    vSelect,
    CalculateProductSalesQuotePricePopUp,
    UpdateCustomerSalesQuotePopUp,
    RmCatalogueErrorPopUp,
  },
  mixins: [Filter, SuccessMessage, ErrorMessages, Calculations],
  data() {
    return {
      id: "",
      itemList: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: "",
      cartItems: [],
      account_currency: "",
      pack_size_options: [],
      customerId: "",
      incoterms: [],
      customer_pack_sizes: [],
      addresses: [],
      is_uk_based_customer: false,
      default_incoterm: 'DDP UK',
    };
  },
  async mounted() {
    this.id = this.$route.params.id;
    await this.fetchSalesQuote();
    await this.getPackSizeList();
    // await this.loadCartItems();
    await this.getIncoterms();
    await this.getCustomerPackSizeSelection();
  },
  methods: {
    async fetchSalesQuote() {
      await this.$vs.loading();
      try {
        const { data } = await CustomerRepository.getSalesQuote(this.id);

        this.itemList = data.data.items.map((item) => ({
          ...item,
          quantity_array: item.quantity,
          price_array: item.price,
          price: item.is_tier ? item.price : item.price[0].price,
          quantity: item.is_tier ? item.quantity : item.quantity[0].quantity,
          incoterm: item.incoterms,
          __source: "sales_quote",
          errors: []
        }));
        this.cartItems.push(...this.itemList);
        this.account_currency = data.data.customer_account_currency;
        this.customerId = data.data.customer_id;
      } catch (e) {}
      this.$vs.loading.close();
    },
    async getPackSizeList() {
      await this.$vs.loading({
        container: "#sample_list",
        scale: 0.45,
      });
      try {
        const { data } = await PackSizeRepository.getListOfPackSize(
          1,
          "",
          100,
          ""
        );
        this.pack_size_options = data.data.map((x) => {
          x.size = this.__removeTrailingZeros(x.size);
          return x;
        });
        this.pack_size_options.push({ size: "custom size" });
      } catch (e) {
        this.convertAndNotifyError(e);
      }
      this.$vs.loading.close(`#sample_list > .con-vs-loading`);
    },

    async getCustomerPackSizeSelection() {
      await this.$vs.loading({
        container: "#sample_list",
        scale: 0.45,
      });
      try {
        const { data } = (
          await CustomerRepository.getCustomerDetails(this.customerId)
        ).data;
        this.customer_pack_sizes =
          data.pack_sizes && data.pack_sizes instanceof Array
            ? data.pack_sizes.map((x) => {
                x.size = this.__removeTrailingZeros(x.size);
                return x;
              })
            : [];
      } catch (e) {
        this.convertAndNotifyError(e);
      }
      this.$vs.loading.close(`#sample_list > .con-vs-loading`);
    },
    async getIncoterms() {
      await this.$vs.loading({
        container: "#sample_list",
        scale: 0.45,
      });
      try {
        const { data } = await IncotermRepository.getListOfIncoterms(
          1,
          "",
          100,
          ""
        );
        this.incoterms = [...data.data].sort((a, b) =>
          a.code === "DDP UK" ? -1 : b.code === "DDP UK" ? 1 : 0
        );
        const find_default_incoterm = this.incoterms.find((x) => x.is_default);
        this.default_incoterm = find_default_incoterm
          ? find_default_incoterm.code
          : "DDP UK";
      } catch (e) {
        this.convertAndNotifyError(e);
      }
      this.$vs.loading.close(`#sample_list > .con-vs-loading`);
    },

    async onClickCalculatePrice(data, index) {

      let formulationId = ""

      if(data.__source === "sales_quote"){
        formulationId = data.formulation_id
      }else if (data.__source === "catalogue"){
        formulationId = data.id
      }else if (data.__source !== "catalogue"){
        formulationId = data.formulation_id
      }

      const result = await CustomerRepository.getListOfCartProductCatalogueSalesQuote(
        this.customerId,
        { formulation_ids: [formulationId] },
        0
      );



      await this.$refs.calculateProductSalesQuotePricePopUp.openPopup(
        result.data.data[0],
        index,
        this.customerId
      );
    },

    async changeQtyLayer(e) {
        
      await this.onChangeQty(e.data, e.index);
    },

    onChangePackSize(data, index) {
      if (data.pack_size !== "custom size") {
        this.onChangeQty(data, index);
      } else {
        this.temp_data = { data, index };
        this.custom_pack_size_val = 0;
        this.active_custom_pack_size_prompt =
          !this.active_custom_pack_size_prompt;
      }
    },

    async onChangeQty(row_data, index) {
      
      let data = {};
      Object.assign(data, row_data);

      if (typeof data.quantity === "undefined" || data.quantity === null) {
        if (
          Array.isArray(data.quantity_array) &&
          data.quantity_array.length > 0
        ) {
          // If 'qty' is undefined or null, but 'quantity_array' exists and is a non-empty array, continue execution
          // Continue with further logic without returning or terminating early
        } else {
          return null;
        }
      }

      data.type = data.type === "List" ? "price" : "contract";
      data.formulation_id = data.formulation_id ? data.formulation_id : data.id
      if (data.type === "price") {
        let unit_price = this.calculateProductListPrice(
          data.pe_g,
          data.quantity,
          data.fx_rate
        );
        this.itemList[index].unit_price = unit_price;
        data.unit_price = unit_price;
        data.is_tier = false;
      }

      // const find  =  this.cartItems.find((m) => m.formulation_id === data.id)
      const find  =  this.cartItems.find((m) => m.formulation_id === data.formulation_id)

      if (find) {
        this.updateCart(data, index, this);
      } else {
        this.addCart(data, index, this);
      }
    },

    addCart: _.debounce(async (data, index, vm) => {
      await vm.onClickAddToCart(data, index);
      // await vm.loadOnlyCartItemCatalogue()
    }, 1500),
    updateCart: _.debounce(async (data, index, vm) => {
      // if(!data.quantity) { return null }
      await vm.onClickUpdateFromCart(data, index);
      // await vm.loadOnlyCartItemCatalogue()
    }, 1500),

     async onClickAddToCart(data, indextr) {
      await this.$vs.loading({
        container: `#sample_list`,
        scale: 0.45,
      });
      try {
        const payload = {};
        payload.customer_id = this.customerId;
        payload.formulation_id = data.id;
        payload.customer_product_code = data.customer_item_code;
        payload.product_code_name = `${data.formulation_code} ${data.name}`;
        
        if(!data.is_tier) {
            payload.quantity_array = [ { quantity: data.quantity } ]
            payload.price_array = [ { price: (Number(data.unit_price)).toFixed(2) } ]
            payload.quantity = data.quantity
            payload.price = (Number(data.unit_price)).toFixed(2)
          } else {
            payload.quantity_array = data.quantity_array
            payload.price_array = data.price_array
            payload.quantity = 'tier'
            payload.price = 'tier'
          }


        payload.quantity_from = data.quantity_from
          ? data.quantity_from
          : data.quantity;
        payload.quantity_to = data.quantity_to
          ? data.quantity_to
          : data.quantity;
        payload.is_tier = data.is_tier;
        payload.type = data.type;
        payload.incoterm = data.incoterm
          ? data.incoterm
          : this.default_incoterm;
        payload.pack_size = data.pack_size
          ? data.pack_size
          : this.isCustomerHasPackSize(data.formulation_type)
          ? this.customerPackSizeFactory(data.formulation_type)
          : this.pack_size_options[0].size;
        payload.lead_time = "";
        payload.estimated_yearly_volume = "";
        payload.valid_from = "";
        payload.valid_to = "";
        payload.__source = "";

        // await CustomerRepository.addFormulationsToProductCart(payload)
        this.cartItems.push(payload);
        this.itemList.push(payload);
        this.itemList = this.itemList.filter(
          (item) => item.__source !== "catalogue"
        );
        this.filters["search"] = "";
      } catch (e) {
      }
      this.$vs.loading.close(`#sample_list > .con-vs-loading`);
    },
    async onClickUpdateFromCart(data, indextr) {
      await this.$vs.loading({
        container: `#sample_list`,
        scale: 0.45,
      });
      const recivedData = data;
      try {
        this.itemList = this.itemList.map((x) => {
          if (x.formulation_id === data.id) {
            if(!data.is_tier) {
              x.quantity_array = [ { quantity: data.quantity } ]
              x.price_array = [ { price: (Number(data.unit_price)).toFixed(2) } ]
              x.quantity = data.quantity
              x.price = Number(data.unit_price).toFixed(2)
            } else {
              x.quantity_array = data.quantity_array
              x.price_array = data.price_array
              x.quantity = 'tier'
              x.price = 'tier'
            }

            

            x.quantity_from = data.quantity_from
              ? data.quantity_from
              : data.quantity;
            x.quantity_to = data.quantity_to ? data.quantity_to : data.quantity;
            x.is_tier = data.is_tier;
            x.incoterm = data.incoterm;
            x.pack_size = data.pack_size ? data.pack_size : "";
            x.type = data.type
            x.__source = "";
          }
          return x;
        });
        // await this.loadProductCart()
        this.filters["search"] = "";
        this.showSuccessMessage("Sales quote updated");
      } catch (e) {
      }
      this.$vs.loading.close(`#sample_list > .con-vs-loading`);
    },

    async loadCartItems() {
      try {
        const { data } =
          await CustomerRepository.getListOfCartProductCatalogueSalesQuote(
            this.customerId,
            { formulation_ids: this.itemList.map((x) => x.formulation_id) },
            0
          );
        this.cartItems = data.data;
      } catch (e) {
      }
    },
    filterQueryUpdate() {
      if (this.filters.search) {
        this.loadProductCart();
      } else {
        this.itemList = this.itemList.filter(
          (item) => item.__source !== "catalogue"
        );
      }
    },
    async loadProductCart() {
      try {
        await this.$vs.loading({
          container: "#sample_list",
          scale: 0.45,
        });
        const { data } =
          await CustomerRepository.getListOfProductCatalogueSalesQuote(
            this.customerId,
            this.filterQuery
          );
        let newItems = data.data
          .map((n) => {
            n.unit_price = "";
            n.__source = "catalogue";
            n.pack_size = this.isCustomerHasPackSize(n.formulation_type) ? this.customerPackSizeFactory(n.formulation_type) : null
            n.incoterm = n.incoterm ? n.incoterm : this.default_incoterm
            return n;
          })
          .sort((a, b) => {
            if (a.type !== "List" && b.type === "List") {
              return -1; // a comes before b
            }
            if (a.type === "List" && b.type !== "List") {
              return 1; // b comes before a
            }
            return 0; // keep their order otherwise
          });

        const existingFormulationIds = new Set(
          this.itemList.map(item => item.formulation_id)
        );

        newItems = newItems.filter(
          item => !existingFormulationIds.has(item.id)
        );

        this.itemList = this.itemList.filter(
          (item) => item.__source !== "catalogue"
        );
        this.itemList.push(...newItems);
      } catch (e) {
        this.convertAndNotifyError(e);
      }
      this.$vs.loading.close("#sample_list > .con-vs-loading");
    },
   
    async onClickRemoveFromCart(id, indextr) {
      await this.$vs.loading({
        container: `#remove_button${indextr}`,
        scale: 0.45,
      });
      try {
        this.itemList = this.itemList.filter((x) => {
          return x.formulation_id !== id;
        });
        this.cartItems = this.cartItems.filter((x) => {
          return x.formulation_id !== id;
        });
      } catch (e) {
        this.convertAndNotifyError(e);
      }
      this.$vs.loading.close(`#remove_button${indextr} > .con-vs-loading`);
    },
    customerPackSizeFactory(formulation_type) {
      let find = this.customer_pack_sizes.find(
        (x) => x.formulation_type === formulation_type
      );
      return find && find.size !== null ? find.size : "0.000";
    },
    isCustomerHasPackSize(formulation_type) {
      let find = this.customer_pack_sizes.find(
        (x) => x.formulation_type === formulation_type
      );
      return !!find;
    },
     backToSalesQuoteList() {
      this.$router.push({path: `/pages/sales-quote`})
    },
    async getAddresses() {
        await this.$vs.loading({
          container: '#sample_list',
          scale: 0.45
        })
        this.addresses = (await CustomerRepository.getCustomerProductDeliveryAddresses(this.customerId)).data.data;
        const find = this.addresses.find((x) => x.country === 'United Kingdom')
        this.is_uk_based_customer = !!find;
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
    async onClickOpenCart() {
      await this.$refs.updateCustomerSalesQuotePopUp.openPopup(this.customerId,this.sample_order_id, this.is_uk_based_customer, this.itemList)
    },
    checkItemInCart: function (object) {
        const arr = this.cartItems.filter((n) => n.formulation_id === object.formulation_id)
        return arr.length > 0
      },
  },
};
</script>
